
const baseGeneralnUrl = "General"

  const endpoints = {
   getCreditOptionList:`${baseGeneralnUrl}/GetCreditOptions`,
   
  };
  
  export default endpoints;